import {
  getQuestionObjFromReducerState,
  isTransitioning,
  setTransitionDirectionFromReducerState
} from "@irati/insights/helpers/question"
import {
  FIRE_CONFETTI_CANNON,
  RELOAD_CONFETTI_CANNON
} from "../actions/confetti"

import {
  UPDATE_TRANSITION_STATE,
  SET_NEXT_QUESTION
} from "../actions/question"

import {UPDATE_DRIVER_LIST} from "../actions/userSurvey"


import {CommentReducer} from "./"


/**
 * Default reducer state
 *
 * @returns {{}}
 * @private
 */
const _getDefaultState = () => ({})


const Survey = (state = {}, action) => {
  const {type, vector} = action
  let baseVector
  let isStateTransitioning

  switch (type) {
    case UPDATE_DRIVER_LIST:
      return {
        ...state,
        drivers: action.drivers
      }
    case SET_NEXT_QUESTION:
      return {
        ...state,
        nextQuestionObj: action.nextQuestionObj,
        questionObj: getQuestionObjFromReducerState(state, action.nextQuestionObj)
      }
    case UPDATE_TRANSITION_STATE:
      isStateTransitioning = isTransitioning(action.transitionState)

      return {
        ...state,
        transitioning: isStateTransitioning,
        transitionState: action.transitionState,
        transitionDirection: setTransitionDirectionFromReducerState(state, action.direction),
        questionObj: getQuestionObjFromReducerState(state, undefined, action.transitionState)
      }
    case FIRE_CONFETTI_CANNON:
      return {
        ...state,
        vector,
        fire: true
      }
    case RELOAD_CONFETTI_CANNON:
      baseVector = [
        {x: window.innerWidth, y: window.innerHeight},
        {x: window.innerWidth * 1.3, y: window.innerHeight * 1.6}
      ]

      return {
        ...state,
        vector: baseVector,
        fire: false
      }
    default:
      return state
  }
}

const SurveyReducer = (state = _getDefaultState(), action) => {
  return {
    ...Survey(state, action),
    comment: CommentReducer(state.comment, action)
  }
}

export default SurveyReducer
